import { createElement, Fragment, isValidElement, memo } from 'react'

import { isEmailSyntaxValid } from '@orus.eu/email'
import { assertDefinedAndNotNull } from '@orus.eu/error'

export const typedMemo: <T>(c: T) => T = memo

// hardcoded while we service only french customers
export const locale = 'fr'
const localeCode = 'fr-FR'

const NUMBER_FORMATTER = new Intl.NumberFormat(localeCode)

export function formatNumber(value: number): string {
  return NUMBER_FORMATTER.format(value)
}

export function getFileDisplayName(fileName: string): string {
  if (fileName.startsWith('Orus - ')) fileName = fileName.substring('Orus - '.length)
  if (fileName.endsWith('.pdf')) fileName = fileName.substring(0, fileName.length - '.pdf'.length)
  fileName = removeTrailingEmail(fileName)
  return fileName
}

function removeTrailingEmail(fileName: string): string {
  const parts = fileName.split(' - ')
  if (parts.length <= 1) {
    return fileName
  }

  const lastPart = assertDefinedAndNotNull(parts.pop(), 'Unexpected undefined string found in string array', {
    fileName,
  })

  const isValidEmail = isEmailSyntaxValid(lastPart)
  if (isValidEmail) {
    return parts.join(' - ')
  }

  return fileName
}

export const isFragment = (element: React.ReactNode): boolean => {
  return isValidElement(element) && (element.type === Fragment || element.type === createElement(Fragment).type)
}
